import { RefObject, useEffect } from 'react';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { fromEvent, Subscription } from 'rxjs';
import { InputRef } from 'antd';

const useTypeAheadSearch = (inputEl: RefObject<InputRef>, handleOnChange: (value: string) => void) => {
  useEffect(() => {
    let subscription: Subscription;
    if (inputEl.current?.input) {
      subscription = fromEvent(inputEl.current.input, 'input')
        .pipe(debounceTime(500), distinctUntilChanged())

        // eslint-disable-next-line
        .subscribe((el: any) => {
          handleOnChange(el.target.value.toLowerCase());
        });
    }
    return () => {
      subscription?.unsubscribe();
    };
  }, [inputEl, handleOnChange]);
};

export default useTypeAheadSearch;
